import { FC } from 'react';
import { Box, TableCell, TableRow } from '@mui/material';
import dayjs from 'dayjs';
import MediumTypography from '../../../components/formlib/MediumTypography';
import { ReactComponent as GroupIcon } from '../../../assets/images/groupIcon.svg';
import { Appointment } from '../../../services/configApi/activitySheet/weeklyActivitySheetProvider';
import { LOCAL_DATE_TIME_UTC_FORMAT } from '../../../services/Constant';
import { IntlShape } from 'react-intl';
import { formatNumberToDecimal } from '../../../utils/utilities';

interface GroupBillingHeaderProps {
  appointment: Appointment;
  rctl: IntlShape;
}

const getFormatedDurationInDecimal = (duration: number | null) =>
  `${formatNumberToDecimal(duration) || '0.00'} hrs`;

const GroupBillingHeader: FC<GroupBillingHeaderProps> = ({
  appointment,
  rctl,
}) => (
  <TableRow>
    <TableCell
      sx={{
        padding: '0px 14px !important',
      }}
      className="border-bottom-0"
    >
      <Box
        display={'flex'}
        alignItems={'center'}
        sx={{
          padding: '0px 8px 0px 0px !important',
          borderBottom: 'none',
          borderLeft: '1px solid #00C6B8',
          height: '100%',
          alignContent: 'center',
          marginLeft: '16px',
        }}
      >
        <Box
          sx={{
            width: '20px',
            backgroundColor: '#00C6B8',
            height: '1px',
          }}
        />
        <GroupIcon />
      </Box>
    </TableCell>
    <TableCell
      colSpan={8}
      sx={{
        borderBottom: 'unset',
        maxWidth: '150px',
      }}
    >
      <Box className={'flex__'}>
        <MediumTypography
          className="mr-sm"
          label={`${rctl.formatMessage({
            id: 'groupBillingText',
            defaultMessage: 'Clinician Group Billable Hours',
          })}:`}
          sxProps={{ fontWeight: 'bold' }}
        />

        <Box sx={{ display: 'flex' }}>
          <MediumTypography
            className="mr-xs"
            label={`${rctl.formatMessage({
              id: 'startTimeText',
              defaultMessage: 'Start Time',
            })} - `}
          />
          <MediumTypography
            className="mr-sm"
            label={`${
              appointment.groupBillingStartTime === null
                ? '00:00'
                : dayjs(
                    appointment.groupBillingStartTime,
                    LOCAL_DATE_TIME_UTC_FORMAT,
                  ).format('hh:mm A')
            };`}
          />
        </Box>

        <Box sx={{ display: 'flex' }}>
          <MediumTypography
            className="mr-xs"
            label={`${rctl.formatMessage({
              id: 'ProgressNote.duration',
              defaultMessage: 'Duration',
            })} - `}
          />
          <MediumTypography
            className="mr-sm"
            label={getFormatedDurationInDecimal(
              appointment.groupBillingDurationDec,
            )}
          />
        </Box>
      </Box>
    </TableCell>
  </TableRow>
);

export default GroupBillingHeader;
